// @file: src/components/navbar/Navbar.js
import styled from "styled-components";
import { Link } from "react-router-dom";

const NavBar = () => {
  return (
    <Container>
      <div className="container">
        <div className="row ">
          <div className="col p-0">
            <img className="p-1" src="/img/logo1.png" alt="Bombeiros ABVESC" />
          </div>
          <div className="col-8 text-center title">
            <Link to="/" className="home-link">
              ESCALA DE SERVIÇO
            </Link>
            <h2>BOMBEIROS VOLUNTÁRIOS DE CAÇADOR</h2>
          </div>

          <div className="col p-0 text-end">
            <img src="/img/logo.png" alt="Bombeiros Caçador" />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default NavBar;

export const Container = styled.div`
  background-color: #b11a1a;
  height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .title {
    margin-top: 10px;

    h2 {
      color: #fff;
      font-weight: bold;
      font-size: 20px;
    }
  }

  .home-link {
    color: #fff;
    font-weight: bold;
    font-size: 28px;

    :hover {
      color: #ffcf4c !important;
    }
  }

  .login {
    a {
      color: #ffcf4c;
      font-size: 12px;
      margin-top: -5px;
      margin-left: -15px;
      position: absolute;

      :hover {
        color: #fff !important;
      }
    }

    svg {
      margin-top: -4px;
    }

    span {
      color: #ffcf4c;
      font-size: 12px;
      margin-top: -5px;
      position: absolute;

      :hover {
        color: #fff !important;
        cursor: pointer;
      }
    }
  }

  span {
    color: #ffcf4c;
  }

  a {
    text-decoration: none;
  }

  img {
    height: 90px;
    margin-top: 10px;
  }

  @media only screen and (max-width: 768px) {
    height: 120px;

    .title {
      margin-top: 20px;

      h2 {
        font-size: 20px;
      }
    }

    img {
      max-height: 100px;
    }
  }

  @media only screen and (max-width: 460px) {
    height: 80px;

    .title {
      margin-top: 0;

      a {
        font-size: 12px;
      }

      h2 {
        font-size: 12px;
      }

      span {
        font-size: 12px;
      }
    }

    img {
      max-height: 55px;
    }
  }

  @media only screen and (max-width: 300px) {
    height: 50px;

    .title {
      margin-top: 0;

      a {
        font-size: 10px;
      }

      h2 {
        font-size: 10px;
      }

      span {
        font-size: 10px;
      }
    }

    img {
      display: none;
    }
  }
`;
